document.addEventListener('DOMContentLoaded', () => {
  const subscriptionSelect = document.querySelector('.product-subscription select');
  const currentPlanId = subscriptionSelect?.getAttribute('data-current-plan-id');
  const subscriptionSwitch = document.querySelector('.subscription-toggle__switch.toggle-switch input');
  const currentVariantInput = document.querySelector(".product-info__buy-buttons form input[name='id']");
  const subscriptionVariants = JSON.parse(
    document.querySelector('.product-subscription [subscription-variants]').textContent
  );

  if (!subscriptionSelect || !subscriptionSwitch || !currentVariantInput) return;

  if (!isPlanAvailableForVariant(currentVariantInput.value, subscriptionVariants, currentPlanId)) {
    handleVariantInputChange();
    handleSubscriptionSelectChange();
  }

  subscriptionSelect.addEventListener('change', handleSubscriptionSelectChange);
  currentVariantInput.addEventListener('change', handleVariantInputChange);
  subscriptionSwitch.addEventListener('change', handleSubscriptionSwitchChange);

  callDispatchEvent();

  function getCurrentVariant(id, variants) {
    return [...variants].find((variant) => variant.id == id);
  }

  function handleVariantInputChange() {
    const variantId = currentVariantInput.value;
    const isPlanAvailable = isPlanAvailableForVariant(variantId, subscriptionVariants, currentPlanId);

    if (!isPlanAvailable) {
      if (subscriptionSwitch.checked) {
        handleAttributeChange('false');
        triggerSubscriptionChange();
      }
      disableSubscriptionSwitch();
    } else {
      enableSubscriptionSwitch();
    }
  }

  function callDispatchEvent() {
    const variantId = document.querySelector(".product-info__buy-buttons form input[name='id']").value;
    document.dispatchEvent(
      new CustomEvent('variant:subscription', {
        bubbles: true,
        detail: {
          variant: getCurrentVariant(variantId, subscriptionVariants),
        },
      })
    );
  }

  function handleSubscriptionSwitchChange() {
    triggerSubscriptionChange();
    handleAttributeChange('true');
  }

  function handleAttributeChange(isManual) {
    subscriptionSwitch.setAttribute('data-manual', isManual);
  }

  function handleSubscriptionSelectChange() {
    const unselectedOption = [...subscriptionSelect.options].find((option) => !option.selected);
    const value = unselectedOption?.value || subscriptionSelect.options[0].value;
    subscriptionSelect.value = value;

    const restElements = document.querySelectorAll('[name="selling_plan"]:not([data-widget])');
    changeOutsideElements(restElements, value);
  }

  function changeOutsideElements(htmlCollection = [], value) {
    [...htmlCollection].forEach((htmlElement) => {
      if (htmlElement instanceof HTMLInputElement) {
        htmlElement.value = value;
      } else if (htmlElement instanceof HTMLSelectElement) {
        const optionExists = [...htmlElement.options].some((opt) => opt.value === value);
        if (optionExists) {
          htmlElement.value = value;
        } else {
          htmlElement.selectedIndex = -1;
        }
      }
    });
  }

  function isPlanAvailableForVariant(variantId, variants, currentPlanId) {
    if (!variantId) return false;

    const variant = variants.find((v) => v.id == variantId);
    if (!variant || !Array.isArray(variant.selling_plan_allocations)) return false;

    return variant.selling_plan_allocations.some(({ selling_plan_id }) => selling_plan_id == currentPlanId);
  }

  function triggerSubscriptionChange() {
    subscriptionSelect.dispatchEvent(new Event('change', { bubbles: true }));
    callDispatchEvent();
  }

  function disableSubscriptionSwitch() {
    subscriptionSwitch.checked = false;
    subscriptionSwitch.setAttribute('disabled', 'disabled');
  }

  function enableSubscriptionSwitch() {
    subscriptionSwitch.removeAttribute('disabled');
  }
});
